import { render, staticRenderFns } from "./NButtonLoading.vue?vue&type=template&id=7e4ac254&scoped=true&"
import script from "./NButtonLoading.vue?vue&type=script&lang=js&"
export * from "./NButtonLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4ac254",
  null
  
)

export default component.exports